import React from 'react';
import { Button } from '@mui/material';

const AddButton = ({ onClick, label = "Add" }) => {
    return (
        <Button
            variant="contained"
            onClick={onClick}
            sx={{
                background: '#5C3685',
                width: '90px',
                height: '40px',
                border: '1px',
                borderRadius: '5px',
                fontFamily: 'Times New Roman',
                fontSize: '18px',
                lineHeight: '20.7px',
                color: '#FFFFFF',
                textTransform:'capitalize'
            }}

        >
            {label}
        </Button>
    );
};

export default AddButton;
